// extracted by mini-css-extract-plugin
module.exports = {"default":"styles__default___24HPo"};